// services/perfil.ts - O perfil do professor no banco da plataforma (entrega 1.6; D84).
//
// A Dinâmica usa o nome (iniciais do botão do perfil) e a letra salva, a mesma do hub. Só lê o documento
// do próprio professor e só grava `readingPrefs`, como as regras da plataforma permitem.

import { doc, onSnapshot, serverTimestamp, setDoc } from 'firebase/firestore';
import type { ReadingPrefs } from '@winieduca/ui';
import { dbPlataforma } from './firebase';

export interface PerfilDaDinamica {
  nome: string | null;
  readingPrefs: ReadingPrefs | null;
}

export function acompanharPerfil(uid: string, aoMudar: (perfil: PerfilDaDinamica | null) => void): () => void {
  return onSnapshot(
    doc(dbPlataforma, 'users', uid),
    (snap) => {
      if (!snap.exists()) return aoMudar(null);
      const d = snap.data() as { name?: string; displayName?: string; readingPrefs?: ReadingPrefs };
      aoMudar({ nome: d.name || d.displayName || null, readingPrefs: d.readingPrefs ?? null });
    },
    () => aoMudar(null),
  );
}

export function salvarLeitura(uid: string, prefs: ReadingPrefs): Promise<void> {
  return setDoc(doc(dbPlataforma, 'users', uid), { readingPrefs: prefs, updatedAt: serverTimestamp() }, { merge: true });
}

/** Iniciais do botão do perfil, como no hub: só palavras que começam com letra. */
export function iniciais(nome: string | null | undefined): string {
  const todas = (nome ?? '').trim().split(/\s+/).filter(Boolean);
  const comLetra = todas.filter((p) => /^\p{L}/u.test(p));
  const partes = comLetra.length ? comLetra : todas;
  const letras = partes.length > 1 ? partes[0][0] + partes[partes.length - 1][0] : (partes[0] ?? '').slice(0, 2);
  return letras.toUpperCase();
}
